// extracted by mini-css-extract-plugin
export var actions = "_8r-8";
export var arrow = "_8r-5";
export var card = "_8r-0";
export var cardWrapper = "_8r-9";
export var fieldName = "_8r-3";
export var newValue = "_8r-6";
export var oldValue = "_8r-4";
export var orangeGlowFade = "_8r-c";
export var productSection = "_8r-1";
export var scrollToBottom = "_8r-b";
export var scrollToBottomAnchor = "_8r-a";
export var scrollToBottomIcon = "_8r-d";
export var showAllButton = "_8r-7";
export var table = "_8r-2";